import { Button, Checkbox, Modal, Switch } from "antd";
import { useContext } from "react";
import { AutomationContext } from "context/AutomationContext";
import Page from "pages/dashboard/automation/page";

export default function AutomationModal({ visible, onClose }) {
  const { streamingCamera } = useContext(AutomationContext);
  return (
    <Modal
      width={1200}
      open={visible}
      title={"Automation - " + streamingCamera?.cameraName}
      onCancel={onClose}
      footer={null}
      centered
      className="automation-modal"
    >
      <div className="flex h-full flex-col md:flex-row md:overflow-hidden bg-white rounded-3xl mr-6 mb-6">
        <div className="flex-grow flex flex-col h-full max-w-full items-center p-6 overflow-x-hidden">
          <Page />
        </div>
      </div>
    </Modal>
  );
}
